import { IconButton, SvgMinusCircle, SvgPlusCircle } from '@loomhq/lens';
import React from 'react';

import styles from './styles.module.less';

const ADD = 'ADD';
const REMOVE = 'REMOVE';

const ToggleSuggestedFollow = ({ type, onClick }) => {
  return (
    <IconButton
      altText={type == ADD ? 'Add' : 'Remove'}
      className={styles.navIcon}
      icon={type == ADD ? <SvgPlusCircle /> : <SvgMinusCircle />}
      iconColor="bodyDimmed"
      size="small"
      onClick={e => {
        e.preventDefault();
        e.stopPropagation();
        onClick();
      }}
    />
  );
};

export const AddSuggestedFollow = ({ onClick }) => (
  <ToggleSuggestedFollow type={ADD} onClick={onClick} />
);

export const RemoveSuggestedFollow = ({ onClick }) => (
  <ToggleSuggestedFollow type={REMOVE} onClick={onClick} />
);

export default ToggleSuggestedFollow;
